// src/pages/admin/AdminConteudo.js

import React, { useEffect, useState } from 'react';
import { getInstitucional, updateInstitucional, getSacramentos, updateSacramento } from '../../services/api';
import Toast from '../../components/common/Toast';

const Section = ({ title, children }) => (
  <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: '1.5rem', boxShadow: 'var(--shadow-sm)', marginBottom: '1.5rem' }}>
    <h3 style={{ fontSize: '1rem', marginBottom: '1.25rem', paddingBottom: '0.75rem', borderBottom: '2px solid var(--gold-pale)' }}>{title}</h3>
    {children}
  </div>
);

const AdminConteudo = () => {
  const [inst, setInst] = useState({ historico: '', endereco: '', telefones: '', missas: '', secretaria: '', paroco: '' });
  const [sacramentos, setSacramentos] = useState([]);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState({});

  useEffect(() => {
    getInstitucional().then(r => { if (r?.data) setInst(r.data); }).catch(() => {});
    getSacramentos().then(r => { if (r?.data?.length) setSacramentos(r.data); }).catch(() => {});
  }, []);

  const saveInst = async () => {
    setLoading(l => ({ ...l, inst: true }));
    try {
      await updateInstitucional(inst);
      setToast({ msg: 'Conteúdo institucional salvo!', type: 'success' });
    } catch {
      setToast({ msg: 'Erro ao salvar.', type: 'error' });
    } finally {
      setLoading(l => ({ ...l, inst: false }));
    }
  };

  const saveSacramento = async (s) => {
    setLoading(l => ({ ...l, [s.id]: true }));
    try {
      await updateSacramento(s);
      setToast({ msg: `${s.titulo} atualizado!`, type: 'success' });
    } catch {
      setToast({ msg: 'Erro ao salvar.', type: 'error' });
    } finally {
      setLoading(l => ({ ...l, [s.id]: false }));
    }
  };

  const updateSac = (id, field, value) => {
    setSacramentos(ss => ss.map(s => s.id === id ? { ...s, [field]: value } : s));
  };

  return (
    <div style={{ padding: '2rem' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      <h1 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>Gerenciar Conteúdo</h1>

      {/* Histórico */}
      <Section title="✏️ Histórico da Paróquia">
        <div className="form-group">
          <label className="form-label">Texto do Histórico</label>
          <textarea className="form-textarea" rows={10} value={inst.historico}
            onChange={e => setInst(i => ({ ...i, historico: e.target.value }))} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn btn-primary btn-sm" onClick={saveInst} disabled={loading.inst}>
            {loading.inst ? 'Salvando...' : 'Salvar Histórico'}
          </button>
        </div>
      </Section>

      {/* Informações institucionais */}
      <Section title="🏛 Informações Institucionais">
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Endereço</label>
            <textarea className="form-textarea" rows={3} value={inst.endereco}
              onChange={e => setInst(i => ({ ...i, endereco: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Telefones</label>
            <textarea className="form-textarea" rows={3} value={inst.telefones}
              onChange={e => setInst(i => ({ ...i, telefones: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Horários das Missas</label>
            <textarea className="form-textarea" rows={4} value={inst.missas}
              onChange={e => setInst(i => ({ ...i, missas: e.target.value }))}
              placeholder="Segunda a Sexta: 7h e 19h&#10;Sábado: 8h e 18h&#10;Domingo: 7h, 9h, 11h e 19h" />
          </div>
          <div className="form-group">
            <label className="form-label">Horários da Secretaria</label>
            <textarea className="form-textarea" rows={4} value={inst.secretaria}
              onChange={e => setInst(i => ({ ...i, secretaria: e.target.value }))} />
          </div>
          <div className="form-group" style={{ gridColumn: '1/-1' }}>
            <label className="form-label">Nome do Pároco</label>
            <input className="form-input" value={inst.paroco}
              onChange={e => setInst(i => ({ ...i, paroco: e.target.value }))} />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn btn-primary btn-sm" onClick={saveInst} disabled={loading.inst}>
            {loading.inst ? 'Salvando...' : 'Salvar Informações'}
          </button>
        </div>
      </Section>

      {/* Sacramentos */}
      {sacramentos.map((s) => (
        <Section key={s.id} title={`${s.icon || '✝'} ${s.titulo}`}>
          <div className="form-group">
            <label className="form-label">Conteúdo</label>
            <textarea className="form-textarea" rows={8} value={s.conteudo}
              onChange={e => updateSac(s.id, 'conteudo', e.target.value)} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn btn-primary btn-sm" onClick={() => saveSacramento(s)} disabled={loading[s.id]}>
              {loading[s.id] ? 'Salvando...' : `Salvar ${s.titulo}`}
            </button>
          </div>
        </Section>
      ))}

      {sacramentos.length === 0 && (
        <div className="alert alert-info">
          Configure as planilhas de sacramentos no Google Sheets para editar o conteúdo aqui.
        </div>
      )}
    </div>
  );
};

export default AdminConteudo;
